import React from "react";
import { useTranslation } from "react-i18next";
import './StaticPages.css';
import './firstPage.css';

const PrivacyPolicyPage = () => {

    const { t } = useTranslation();

    const localLanguage = localStorage.getItem('language');


    return (
        <>
            <div className="privacyPolicyPage">
                <div className="privacyPolicyHeader">
                    <h1>Privacy Policy</h1>
                </div>

                <div className="privacyPolicyText">
                    Monda application is created to collect and publish graphic design content, photo and video editing features, and creative tools for content creation in social networks in multiple languages. By using the Monda application, you, as our user, accept all the terms mentioned in this document.
                </div>
                <div className="privacyPolicyText">
                    Please read the following document carefully. If you do not agree with the “Privacy Policy,” you should immediately stop using this site and application.
                </div>
                <div className="privacyPolicyText">
                    Although precision and reasonable efforts have been used to check the accuracy of the information provided on the site and application, their precision and accuracy cannot be guaranteed or claimed in any way. You are advised to verify the information before relying on it. Additionally, due to the nature of the Internet, errors, interruptions, and delays in the service may occur at any time. Based on this, the information on our site and application is provided without any guarantees, and we do not accept any obligation or responsibility for the accuracy of the information, deletion of information, or interruption of access.
                </div>
                <div className="privacyPolicyText">
                    Your use, browsing, and searching in the Monda application are done at your own responsibility.

                </div>
                <div className="privacyPolicyText">
                    The Monda application has no liability for direct, incidental, consequential, indirect, and criminal damages arising from your access and use of the application.

                </div>
                <div className="privacyPolicyText">

                    Monda is not responsible for the information on other websites that are related to our site, linked to, or linked to in the application. These sites are created by persons or companies other than Monda.

                </div>

                <div className="privacyPolicyText">
                    The application does not act as a publisher or promoter of the content contained in these websites.

                </div>
                <div className="privacyPolicyText">
                    Any misuse of Monda’s name and related services is prohibited.

                </div>

                <div className="privacyPolicyText">
                    <span>If you have any concerns or unclear points in this agreement, please contact us via </span>
                    <span><a href="mailto:info@mondaa.ir">info@mondaa.ir</a></span>
                </div>

                <div className="privacyPolicyText">
                    Monda can revise this “Privacy Policy” at any time by updating the terms of use of the application. In case such a change is made, Monda will inform the users about this issue.
                </div>

            </div>
            <div className="firstPageContent">
                <div id="start" className="footer3">
                    <div className="container ondark container-narrow">
                        <div className="col lg-5 sm-12 flex flex-vertical">
                            <img src={require('../../assets/images/vibinoLogoW.svg')} alt="" className="logoFooter" />
                            <br />
                            <div className="margin-bottom">
                                {t('contents:vibinoAddress')}
                                <br />
                                <br />
                                {t('contents:vibinoEmail')}
                                <br />
                                <br />
                                {t('contents:vibinoTelephone')}
                                <br />
                                {/*{t('contents:vibinoFax')} */}
                            </div>
                            <div className="social-links">
                                <a className="social instagram" target="_blank" href="https://www.instagram.com/vibino.fa/"></a>
                                <a className="social aparat" target="_blank" href="https://www.aparat.com/ViBiNO"></a>
                                <a className="social youtube" target="_blank" href="https://www.youtube.com/channel/UCb2szQp2lyxJg-OUCehgOqg"></a>
                                <a className="social linkedin" target="_blank" href="https://www.linkedin.com/company/vibino"></a>
                            </div>
                        </div>
                        <div className="col lg-3 sm-12 align-top">
                            <h3 className="footer-widget-title">{t('contents:vibino')}</h3>
                            <div className="footer-links2">
                                <a href="#aboutVibino" className="footer-link-item2">
                                    {t('whatIsVibino')}
                                    <br />
                                </a>
                                <a href="#usages" className="footer-link-item2">
                                    {t('usage')}
                                </a>
                                <a href="#features" className="footer-link-item2">
                                    {t('features')}
                                </a>
                                {/* <a href="#subscribe" className="footer-link-item2">
                    {t('subscribe')}
                </a> */}
                                <a href="#home" className="footer-link-item2">
                                    {t('register')}
                                </a>
                            </div>
                        </div>
                        {localLanguage === 'rtl/fa-IR' && (
                            <div className="col lg-5 sm-12 align-top">
                                <div className="enamad">
                                    <a
                                        referrerPolicy="origin"
                                        target="_blank"
                                        href="https://trustseal.enamad.ir/?id=197704&amp;Code=u9OHv3dLXjPRK5zO7ACd"
                                    >
                                        <img
                                            referrerPolicy="origin"
                                            src="https://Trustseal.eNamad.ir/logo.aspx?id=197704&amp;Code=u9OHv3dLXjPRK5zO7ACd"
                                            alt=""
                                            style={{ cursor: 'pointer' }}
                                            id="u9OHv3dLXjPRK5zO7ACd"
                                        />
                                    </a>
                                </div>
                                {/* <div className="samandehi">
                    <img
                    id="nbqejxlzesgtesgtoeukapfu"
                    style={{ cursor: 'pointer' }}
                    onClick='window.open("https://logo.samandehi.ir/Verify.aspx?id=210085&p=uiwkrfthobpdobpdmcsidshw", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
                    alt="logo-samandehi"
                    src="https://logo.samandehi.ir/logo.aspx?id=210085&p=odrfnbpdlymalymaaqgwujyn"
                    />
                </div> */}
                            </div>
                        )}
                    </div>
                    <div className="container ondark container-narrow">
                        <div className="col lg-12 sm-12 flex">
                            <div style={{ width: '100%', display: 'block', textAlign: 'center' }}>
                                <div>{t('contents:vibinoCopyright')}</div>
                                <a className="footer-link-item2 margin-right pointerNormal">{t('websiteTerm')}</a>

                                <a href='/privacy-policy' className="footer-link-item2">{t('privacyPolicy')}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PrivacyPolicyPage;
